<template>
    <div class="fixed inset-0 bg-black/30 flex justify-center items-center backdrop-blur-sm z-50">
        <div class="flex flex-col items-center animate-fade-in">
            <!-- Rotating bottle cap -->
            <img :src="capImage" alt="Bottle Cap" class="w-24 h-24 cap-img" aria-hidden="true" />

            <!-- Small label below -->
            <p class="mt-4 text-white font-semibold text-lg">
                Ouverture réussie !
            </p>
        </div>
    </div>
</template>

<script setup>
import { onMounted, ref } from 'vue';
import { useParticipationStore } from "@/stores/useParticipationStore"

const participationStore = useParticipationStore()


const capImage = ref('cocacolaBottleCap.png');

onMounted(() => {

    const brand = participationStore.participation?.brand ?? "cocacola";
    console.log('brand :>> ', brand);
    try {
        capImage.value = `bottleCaps/${brand}BottleCap.png`;

        console.log('capImage.value :>> ', capImage.value);
    } catch (e) {
        console.error("Image not found:", e);
    }


})
</script>

<style scoped>
.cap-img {
    /* make sure the rotation pivot is centered */
    transform-origin: 50% 50%;
    /* ensure the animation keeps final state */
    animation: twist-rtl 1200ms cubic-bezier(.22, .9, .33, 1) forwards;
}

/* rotate from upside-down (180deg) toward 0deg (counterclockwise/right->left)
   with a little overshoot and settle for realism */
@keyframes twist-rtl {
    0% {
        transform: rotate(180deg) scale(1);
        /* start upside down */
        opacity: 1;
    }

    40% {
        transform: rotate(90deg) scale(1.15);
        /* quick mid-twist (counterclockwise) */
    }

    70% {
        transform: rotate(-10deg) scale(1.05);
        /* slight overshoot past upright */
    }

    100% {
        transform: rotate(0deg) scale(1);
        /* final upright */
    }
}

@keyframes fade-in {
    from {
        opacity: 0;
        transform: scale(0.95);
    }

    to {
        opacity: 1;
        transform: scale(1);
    }
}

.animate-fade-in {
    animation: fade-in 0.4s ease-out;
}
</style>
